"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.10
//   protoc               v6.33.5
// source: protos/charger-ui-interface.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageFromUI = exports.UseMembershipPresentedAsPayment = exports.GetCtepParameterLog = exports.ValidateMembership = exports.ResourceReport = exports.ResourceStat = exports.FeedbackProvided = exports.Heartbeat = exports.SendLog = exports.GenerateReceipt = exports.CancelTransaction = exports.ProblemReported = exports.AssignPayment = exports.AssignMembership = exports.StopCharging = exports.MessageToUI = exports.CtepParameterLog = exports.CtepParameter = exports.PricingChangedSinceLastSession = exports.SetUiConfig = exports.GetResourceReport = exports.HeartbeatResponse = exports.PaymentPresented = exports.PaymentAuthorized = exports.PaymentError = exports.ConnectorPlugStatusChange = exports.TransactionFinished = exports.StatusUpdate = exports.ChargerState = exports.MembershipState = exports.PortState = exports.TransactionState = exports.transactionFinished_FaultTypeToJSON = exports.transactionFinished_FaultTypeFromJSON = exports.TransactionFinished_FaultType = exports.transactionFinished_StatusToJSON = exports.transactionFinished_StatusFromJSON = exports.TransactionFinished_Status = exports.transactionState_StateToJSON = exports.transactionState_StateFromJSON = exports.TransactionState_State = exports.logSeverityToJSON = exports.logSeverityFromJSON = exports.LogSeverity = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const timestamp_1 = require("../google/protobuf/timestamp");
const charger_1 = require("./charger");
const money_1 = require("./money");
exports.protobufPackage = "charger_ui";
var LogSeverity;
(function (LogSeverity) {
    LogSeverity[LogSeverity["Information"] = 0] = "Information";
    LogSeverity[LogSeverity["Error"] = 1] = "Error";
    LogSeverity[LogSeverity["Critical"] = 2] = "Critical";
    LogSeverity[LogSeverity["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LogSeverity = exports.LogSeverity || (exports.LogSeverity = {}));
function logSeverityFromJSON(object) {
    switch (object) {
        case 0:
        case "Information":
            return LogSeverity.Information;
        case 1:
        case "Error":
            return LogSeverity.Error;
        case 2:
        case "Critical":
            return LogSeverity.Critical;
        case -1:
        case "UNRECOGNIZED":
        default:
            return LogSeverity.UNRECOGNIZED;
    }
}
exports.logSeverityFromJSON = logSeverityFromJSON;
function logSeverityToJSON(object) {
    switch (object) {
        case LogSeverity.Information:
            return "Information";
        case LogSeverity.Error:
            return "Error";
        case LogSeverity.Critical:
            return "Critical";
        case LogSeverity.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.logSeverityToJSON = logSeverityToJSON;
/** A state for the transaction. */
var TransactionState_State;
(function (TransactionState_State) {
    TransactionState_State[TransactionState_State["STATE_PREPARING"] = 0] = "STATE_PREPARING";
    TransactionState_State[TransactionState_State["STATE_CHARGING"] = 1] = "STATE_CHARGING";
    TransactionState_State[TransactionState_State["STATE_FINISHING"] = 2] = "STATE_FINISHING";
    TransactionState_State[TransactionState_State["STATE_FAULTED"] = 3] = "STATE_FAULTED";
    TransactionState_State[TransactionState_State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TransactionState_State = exports.TransactionState_State || (exports.TransactionState_State = {}));
function transactionState_StateFromJSON(object) {
    switch (object) {
        case 0:
        case "STATE_PREPARING":
            return TransactionState_State.STATE_PREPARING;
        case 1:
        case "STATE_CHARGING":
            return TransactionState_State.STATE_CHARGING;
        case 2:
        case "STATE_FINISHING":
            return TransactionState_State.STATE_FINISHING;
        case 3:
        case "STATE_FAULTED":
            return TransactionState_State.STATE_FAULTED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TransactionState_State.UNRECOGNIZED;
    }
}
exports.transactionState_StateFromJSON = transactionState_StateFromJSON;
function transactionState_StateToJSON(object) {
    switch (object) {
        case TransactionState_State.STATE_PREPARING:
            return "STATE_PREPARING";
        case TransactionState_State.STATE_CHARGING:
            return "STATE_CHARGING";
        case TransactionState_State.STATE_FINISHING:
            return "STATE_FINISHING";
        case TransactionState_State.STATE_FAULTED:
            return "STATE_FAULTED";
        case TransactionState_State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.transactionState_StateToJSON = transactionState_StateToJSON;
/** The status of the transaction. */
var TransactionFinished_Status;
(function (TransactionFinished_Status) {
    TransactionFinished_Status[TransactionFinished_Status["SUCCESS"] = 0] = "SUCCESS";
    TransactionFinished_Status[TransactionFinished_Status["FAILED"] = 1] = "FAILED";
    TransactionFinished_Status[TransactionFinished_Status["FAILED_OUR_FAULT"] = 2] = "FAILED_OUR_FAULT";
    TransactionFinished_Status[TransactionFinished_Status["FAILED_CANNOT_CALCULATE_ENERGY_DIPSENSED"] = 3] = "FAILED_CANNOT_CALCULATE_ENERGY_DIPSENSED";
    TransactionFinished_Status[TransactionFinished_Status["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TransactionFinished_Status = exports.TransactionFinished_Status || (exports.TransactionFinished_Status = {}));
function transactionFinished_StatusFromJSON(object) {
    switch (object) {
        case 0:
        case "SUCCESS":
            return TransactionFinished_Status.SUCCESS;
        case 1:
        case "FAILED":
            return TransactionFinished_Status.FAILED;
        case 2:
        case "FAILED_OUR_FAULT":
            return TransactionFinished_Status.FAILED_OUR_FAULT;
        case 3:
        case "FAILED_CANNOT_CALCULATE_ENERGY_DIPSENSED":
            return TransactionFinished_Status.FAILED_CANNOT_CALCULATE_ENERGY_DIPSENSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TransactionFinished_Status.UNRECOGNIZED;
    }
}
exports.transactionFinished_StatusFromJSON = transactionFinished_StatusFromJSON;
function transactionFinished_StatusToJSON(object) {
    switch (object) {
        case TransactionFinished_Status.SUCCESS:
            return "SUCCESS";
        case TransactionFinished_Status.FAILED:
            return "FAILED";
        case TransactionFinished_Status.FAILED_OUR_FAULT:
            return "FAILED_OUR_FAULT";
        case TransactionFinished_Status.FAILED_CANNOT_CALCULATE_ENERGY_DIPSENSED:
            return "FAILED_CANNOT_CALCULATE_ENERGY_DIPSENSED";
        case TransactionFinished_Status.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.transactionFinished_StatusToJSON = transactionFinished_StatusToJSON;
/** The type of fault that caused the transaction to fail. */
var TransactionFinished_FaultType;
(function (TransactionFinished_FaultType) {
    TransactionFinished_FaultType[TransactionFinished_FaultType["UNKNOWN"] = 0] = "UNKNOWN";
    TransactionFinished_FaultType[TransactionFinished_FaultType["GENERAL_E_STOP_PRESSED"] = 1] = "GENERAL_E_STOP_PRESSED";
    TransactionFinished_FaultType[TransactionFinished_FaultType["GENERAL_CCS_COMMUNICATIONS_FAILURE"] = 2] = "GENERAL_CCS_COMMUNICATIONS_FAILURE";
    TransactionFinished_FaultType[TransactionFinished_FaultType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TransactionFinished_FaultType = exports.TransactionFinished_FaultType || (exports.TransactionFinished_FaultType = {}));
function transactionFinished_FaultTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN":
            return TransactionFinished_FaultType.UNKNOWN;
        case 1:
        case "GENERAL_E_STOP_PRESSED":
            return TransactionFinished_FaultType.GENERAL_E_STOP_PRESSED;
        case 2:
        case "GENERAL_CCS_COMMUNICATIONS_FAILURE":
            return TransactionFinished_FaultType.GENERAL_CCS_COMMUNICATIONS_FAILURE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TransactionFinished_FaultType.UNRECOGNIZED;
    }
}
exports.transactionFinished_FaultTypeFromJSON = transactionFinished_FaultTypeFromJSON;
function transactionFinished_FaultTypeToJSON(object) {
    switch (object) {
        case TransactionFinished_FaultType.UNKNOWN:
            return "UNKNOWN";
        case TransactionFinished_FaultType.GENERAL_E_STOP_PRESSED:
            return "GENERAL_E_STOP_PRESSED";
        case TransactionFinished_FaultType.GENERAL_CCS_COMMUNICATIONS_FAILURE:
            return "GENERAL_CCS_COMMUNICATIONS_FAILURE";
        case TransactionFinished_FaultType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.transactionFinished_FaultTypeToJSON = transactionFinished_FaultTypeToJSON;
function createBaseTransactionState() {
    return {
        vehicleSoc: 0,
        kWhConsumed: 0,
        sessionDurationSeconds: 0,
        powerKw: 0,
        chargerAvailableKw: 0,
        costSoFar: undefined,
        state: 0,
        pricing: undefined,
        vehicleLimited: false,
        costBreakdown: undefined,
        chargingEndTime: undefined,
    };
}
exports.TransactionState = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.vehicleSoc !== 0) {
            writer.uint32(13).float(message.vehicleSoc);
        }
        if (message.kWhConsumed !== 0) {
            writer.uint32(21).float(message.kWhConsumed);
        }
        if (message.sessionDurationSeconds !== 0) {
            writer.uint32(24).uint32(message.sessionDurationSeconds);
        }
        if (message.powerKw !== 0) {
            writer.uint32(37).float(message.powerKw);
        }
        if (message.chargerAvailableKw !== 0) {
            writer.uint32(53).float(message.chargerAvailableKw);
        }
        if (message.costSoFar !== undefined) {
            money_1.Money.encode(message.costSoFar, writer.uint32(66).fork()).join();
        }
        if (message.state !== 0) {
            writer.uint32(72).int32(message.state);
        }
        if (message.pricing !== undefined) {
            money_1.PricingModel.encode(message.pricing, writer.uint32(82).fork()).join();
        }
        if (message.vehicleLimited !== false) {
            writer.uint32(88).bool(message.vehicleLimited);
        }
        if (message.costBreakdown !== undefined) {
            money_1.ChargeBreakdown.encode(message.costBreakdown, writer.uint32(98).fork()).join();
        }
        if (message.chargingEndTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.chargingEndTime), writer.uint32(106).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransactionState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 13) {
                        break;
                    }
                    message.vehicleSoc = reader.float();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.kWhConsumed = reader.float();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.sessionDurationSeconds = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 37) {
                        break;
                    }
                    message.powerKw = reader.float();
                    continue;
                }
                case 6: {
                    if (tag !== 53) {
                        break;
                    }
                    message.chargerAvailableKw = reader.float();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.costSoFar = money_1.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.state = reader.int32();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.pricing = money_1.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.vehicleLimited = reader.bool();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.costBreakdown = money_1.ChargeBreakdown.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.chargingEndTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            vehicleSoc: isSet(object.vehicleSoc)
                ? globalThis.Number(object.vehicleSoc)
                : isSet(object.vehicle_soc)
                    ? globalThis.Number(object.vehicle_soc)
                    : 0,
            kWhConsumed: isSet(object.kWhConsumed)
                ? globalThis.Number(object.kWhConsumed)
                : isSet(object.kWh_consumed)
                    ? globalThis.Number(object.kWh_consumed)
                    : 0,
            sessionDurationSeconds: isSet(object.sessionDurationSeconds)
                ? globalThis.Number(object.sessionDurationSeconds)
                : isSet(object.session_duration_seconds)
                    ? globalThis.Number(object.session_duration_seconds)
                    : 0,
            powerKw: isSet(object.powerKw)
                ? globalThis.Number(object.powerKw)
                : isSet(object.power_kw)
                    ? globalThis.Number(object.power_kw)
                    : 0,
            chargerAvailableKw: isSet(object.chargerAvailableKw)
                ? globalThis.Number(object.chargerAvailableKw)
                : isSet(object.charger_available_kw)
                    ? globalThis.Number(object.charger_available_kw)
                    : 0,
            costSoFar: isSet(object.costSoFar)
                ? money_1.Money.fromJSON(object.costSoFar)
                : isSet(object.cost_so_far)
                    ? money_1.Money.fromJSON(object.cost_so_far)
                    : undefined,
            state: isSet(object.state)
                ? transactionState_StateFromJSON(object.state)
                : 0,
            pricing: isSet(object.pricing)
                ? money_1.PricingModel.fromJSON(object.pricing)
                : undefined,
            vehicleLimited: isSet(object.vehicleLimited)
                ? globalThis.Boolean(object.vehicleLimited)
                : isSet(object.vehicle_limited)
                    ? globalThis.Boolean(object.vehicle_limited)
                    : false,
            costBreakdown: isSet(object.costBreakdown)
                ? money_1.ChargeBreakdown.fromJSON(object.costBreakdown)
                : isSet(object.cost_breakdown)
                    ? money_1.ChargeBreakdown.fromJSON(object.cost_breakdown)
                    : undefined,
            chargingEndTime: isSet(object.chargingEndTime)
                ? fromJsonTimestamp(object.chargingEndTime)
                : isSet(object.charging_end_time)
                    ? fromJsonTimestamp(object.charging_end_time)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.vehicleSoc !== 0) {
            obj.vehicleSoc = message.vehicleSoc;
        }
        if (message.kWhConsumed !== 0) {
            obj.kWhConsumed = message.kWhConsumed;
        }
        if (message.sessionDurationSeconds !== 0) {
            obj.sessionDurationSeconds = Math.round(message.sessionDurationSeconds);
        }
        if (message.powerKw !== 0) {
            obj.powerKw = message.powerKw;
        }
        if (message.chargerAvailableKw !== 0) {
            obj.chargerAvailableKw = message.chargerAvailableKw;
        }
        if (message.costSoFar !== undefined) {
            obj.costSoFar = money_1.Money.toJSON(message.costSoFar);
        }
        if (message.state !== 0) {
            obj.state = transactionState_StateToJSON(message.state);
        }
        if (message.pricing !== undefined) {
            obj.pricing = money_1.PricingModel.toJSON(message.pricing);
        }
        if (message.vehicleLimited !== false) {
            obj.vehicleLimited = message.vehicleLimited;
        }
        if (message.costBreakdown !== undefined) {
            obj.costBreakdown = money_1.ChargeBreakdown.toJSON(message.costBreakdown);
        }
        if (message.chargingEndTime !== undefined) {
            obj.chargingEndTime = message.chargingEndTime.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.TransactionState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionState();
        message.vehicleSoc = object.vehicleSoc ?? 0;
        message.kWhConsumed = object.kWhConsumed ?? 0;
        message.sessionDurationSeconds = object.sessionDurationSeconds ?? 0;
        message.powerKw = object.powerKw ?? 0;
        message.chargerAvailableKw = object.chargerAvailableKw ?? 0;
        message.costSoFar =
            object.costSoFar !== undefined && object.costSoFar !== null
                ? money_1.Money.fromPartial(object.costSoFar)
                : undefined;
        message.state = object.state ?? 0;
        message.pricing =
            object.pricing !== undefined && object.pricing !== null
                ? money_1.PricingModel.fromPartial(object.pricing)
                : undefined;
        message.vehicleLimited = object.vehicleLimited ?? false;
        message.costBreakdown =
            object.costBreakdown !== undefined && object.costBreakdown !== null
                ? money_1.ChargeBreakdown.fromPartial(object.costBreakdown)
                : undefined;
        message.chargingEndTime = object.chargingEndTime ?? undefined;
        return message;
    },
};
function createBasePortState() {
    return {
        portId: 0,
        transactionState: undefined,
        pluggedIn: false,
        paymentAccepted: false,
        portType: 0,
        maxChargeRateKw: 0,
        available: false,
        totalizerKwh: 0,
        membershipState: undefined,
        pluggedInTime: undefined,
    };
}
exports.PortState = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.portId !== 0) {
            writer.uint32(8).uint32(message.portId);
        }
        if (message.transactionState !== undefined) {
            exports.TransactionState.encode(message.transactionState, writer.uint32(18).fork()).join();
        }
        if (message.pluggedIn !== false) {
            writer.uint32(24).bool(message.pluggedIn);
        }
        if (message.paymentAccepted !== false) {
            writer.uint32(32).bool(message.paymentAccepted);
        }
        if (message.portType !== 0) {
            writer.uint32(40).int32(message.portType);
        }
        if (message.maxChargeRateKw !== 0) {
            writer.uint32(48).uint32(message.maxChargeRateKw);
        }
        if (message.available !== false) {
            writer.uint32(56).bool(message.available);
        }
        if (message.totalizerKwh !== 0) {
            writer.uint32(69).float(message.totalizerKwh);
        }
        if (message.membershipState !== undefined) {
            exports.MembershipState.encode(message.membershipState, writer.uint32(74).fork()).join();
        }
        if (message.pluggedInTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.pluggedInTime), writer.uint32(82).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePortState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.portId = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.transactionState = exports.TransactionState.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.pluggedIn = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.paymentAccepted = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.portType = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.maxChargeRateKw = reader.uint32();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.available = reader.bool();
                    continue;
                }
                case 8: {
                    if (tag !== 69) {
                        break;
                    }
                    message.totalizerKwh = reader.float();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.membershipState = exports.MembershipState.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.pluggedInTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : 0,
            transactionState: isSet(object.transactionState)
                ? exports.TransactionState.fromJSON(object.transactionState)
                : isSet(object.transaction_state)
                    ? exports.TransactionState.fromJSON(object.transaction_state)
                    : undefined,
            pluggedIn: isSet(object.pluggedIn)
                ? globalThis.Boolean(object.pluggedIn)
                : isSet(object.plugged_in)
                    ? globalThis.Boolean(object.plugged_in)
                    : false,
            paymentAccepted: isSet(object.paymentAccepted)
                ? globalThis.Boolean(object.paymentAccepted)
                : isSet(object.payment_accepted)
                    ? globalThis.Boolean(object.payment_accepted)
                    : false,
            portType: isSet(object.portType)
                ? (0, charger_1.portTypeFromJSON)(object.portType)
                : isSet(object.port_type)
                    ? (0, charger_1.portTypeFromJSON)(object.port_type)
                    : 0,
            maxChargeRateKw: isSet(object.maxChargeRateKw)
                ? globalThis.Number(object.maxChargeRateKw)
                : isSet(object.max_charge_rate_kw)
                    ? globalThis.Number(object.max_charge_rate_kw)
                    : 0,
            available: isSet(object.available)
                ? globalThis.Boolean(object.available)
                : false,
            totalizerKwh: isSet(object.totalizerKwh)
                ? globalThis.Number(object.totalizerKwh)
                : isSet(object.totalizer_kwh)
                    ? globalThis.Number(object.totalizer_kwh)
                    : 0,
            membershipState: isSet(object.membershipState)
                ? exports.MembershipState.fromJSON(object.membershipState)
                : isSet(object.membership_state)
                    ? exports.MembershipState.fromJSON(object.membership_state)
                    : undefined,
            pluggedInTime: isSet(object.pluggedInTime)
                ? fromJsonTimestamp(object.pluggedInTime)
                : isSet(object.plugged_in_time)
                    ? fromJsonTimestamp(object.plugged_in_time)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.portId !== 0) {
            obj.portId = Math.round(message.portId);
        }
        if (message.transactionState !== undefined) {
            obj.transactionState = exports.TransactionState.toJSON(message.transactionState);
        }
        if (message.pluggedIn !== false) {
            obj.pluggedIn = message.pluggedIn;
        }
        if (message.paymentAccepted !== false) {
            obj.paymentAccepted = message.paymentAccepted;
        }
        if (message.portType !== 0) {
            obj.portType = (0, charger_1.portTypeToJSON)(message.portType);
        }
        if (message.maxChargeRateKw !== 0) {
            obj.maxChargeRateKw = Math.round(message.maxChargeRateKw);
        }
        if (message.available !== false) {
            obj.available = message.available;
        }
        if (message.totalizerKwh !== 0) {
            obj.totalizerKwh = message.totalizerKwh;
        }
        if (message.membershipState !== undefined) {
            obj.membershipState = exports.MembershipState.toJSON(message.membershipState);
        }
        if (message.pluggedInTime !== undefined) {
            obj.pluggedInTime = message.pluggedInTime.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.PortState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePortState();
        message.portId = object.portId ?? 0;
        message.transactionState =
            object.transactionState !== undefined && object.transactionState !== null
                ? exports.TransactionState.fromPartial(object.transactionState)
                : undefined;
        message.pluggedIn = object.pluggedIn ?? false;
        message.paymentAccepted = object.paymentAccepted ?? false;
        message.portType = object.portType ?? 0;
        message.maxChargeRateKw = object.maxChargeRateKw ?? 0;
        message.available = object.available ?? false;
        message.totalizerKwh = object.totalizerKwh ?? 0;
        message.membershipState =
            object.membershipState !== undefined && object.membershipState !== null
                ? exports.MembershipState.fromPartial(object.membershipState)
                : undefined;
        message.pluggedInTime = object.pluggedInTime ?? undefined;
        return message;
    },
};
function createBaseMembershipState() {
    return {
        isValid: false,
        validMembershipExpiration: undefined,
        membershipInvalidDisplayMessage: "",
        membershipCanBeUsedAsPayment: false,
    };
}
exports.MembershipState = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.isValid !== false) {
            writer.uint32(8).bool(message.isValid);
        }
        if (message.validMembershipExpiration !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.validMembershipExpiration), writer.uint32(18).fork()).join();
        }
        if (message.membershipInvalidDisplayMessage !== "") {
            writer.uint32(26).string(message.membershipInvalidDisplayMessage);
        }
        if (message.membershipCanBeUsedAsPayment !== false) {
            writer.uint32(32).bool(message.membershipCanBeUsedAsPayment);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMembershipState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.isValid = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.validMembershipExpiration = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.membershipInvalidDisplayMessage = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.membershipCanBeUsedAsPayment = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            isValid: isSet(object.isValid)
                ? globalThis.Boolean(object.isValid)
                : isSet(object.is_valid)
                    ? globalThis.Boolean(object.is_valid)
                    : false,
            validMembershipExpiration: isSet(object.validMembershipExpiration)
                ? fromJsonTimestamp(object.validMembershipExpiration)
                : isSet(object.valid_membership_expiration)
                    ? fromJsonTimestamp(object.valid_membership_expiration)
                    : undefined,
            membershipInvalidDisplayMessage: isSet(object.membershipInvalidDisplayMessage)
                ? globalThis.String(object.membershipInvalidDisplayMessage)
                : isSet(object.membership_invalid_display_message)
                    ? globalThis.String(object.membership_invalid_display_message)
                    : "",
            membershipCanBeUsedAsPayment: isSet(object.membershipCanBeUsedAsPayment)
                ? globalThis.Boolean(object.membershipCanBeUsedAsPayment)
                : isSet(object.membership_can_be_used_as_payment)
                    ? globalThis.Boolean(object.membership_can_be_used_as_payment)
                    : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.isValid !== false) {
            obj.isValid = message.isValid;
        }
        if (message.validMembershipExpiration !== undefined) {
            obj.validMembershipExpiration =
                message.validMembershipExpiration.toISOString();
        }
        if (message.membershipInvalidDisplayMessage !== "") {
            obj.membershipInvalidDisplayMessage =
                message.membershipInvalidDisplayMessage;
        }
        if (message.membershipCanBeUsedAsPayment !== false) {
            obj.membershipCanBeUsedAsPayment = message.membershipCanBeUsedAsPayment;
        }
        return obj;
    },
    create(base) {
        return exports.MembershipState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMembershipState();
        message.isValid = object.isValid ?? false;
        message.validMembershipExpiration =
            object.validMembershipExpiration ?? undefined;
        message.membershipInvalidDisplayMessage =
            object.membershipInvalidDisplayMessage ?? "";
        message.membershipCanBeUsedAsPayment =
            object.membershipCanBeUsedAsPayment ?? false;
        return message;
    },
};
function createBaseChargerState() {
    return {
        maxChargeRateKw: 0,
        pricing: undefined,
        available: false,
        timeOffsetFromUtcSeconds: 0,
        branding: "",
        eStopPressed: false,
        softwareVersion: "",
        friendlyChargerId: 0,
        ctepCertificateNumber: "",
        powerLimitedHighUtilization: false,
        organizationName: "",
        membershipValidation: undefined,
        otherEStopPressed: false,
    };
}
exports.ChargerState = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.maxChargeRateKw !== 0) {
            writer.uint32(8).uint32(message.maxChargeRateKw);
        }
        if (message.pricing !== undefined) {
            money_1.PricingModel.encode(message.pricing, writer.uint32(18).fork()).join();
        }
        if (message.available !== false) {
            writer.uint32(24).bool(message.available);
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            writer.uint32(32).int32(message.timeOffsetFromUtcSeconds);
        }
        if (message.branding !== "") {
            writer.uint32(42).string(message.branding);
        }
        if (message.eStopPressed !== false) {
            writer.uint32(48).bool(message.eStopPressed);
        }
        if (message.softwareVersion !== "") {
            writer.uint32(58).string(message.softwareVersion);
        }
        if (message.friendlyChargerId !== 0) {
            writer.uint32(64).int32(message.friendlyChargerId);
        }
        if (message.ctepCertificateNumber !== "") {
            writer.uint32(74).string(message.ctepCertificateNumber);
        }
        if (message.powerLimitedHighUtilization !== false) {
            writer.uint32(80).bool(message.powerLimitedHighUtilization);
        }
        if (message.organizationName !== "") {
            writer.uint32(90).string(message.organizationName);
        }
        if (message.membershipValidation !== undefined) {
            charger_1.MembershipValidation.encode(message.membershipValidation, writer.uint32(98).fork()).join();
        }
        if (message.otherEStopPressed !== false) {
            writer.uint32(104).bool(message.otherEStopPressed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargerState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.maxChargeRateKw = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.pricing = money_1.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.available = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.timeOffsetFromUtcSeconds = reader.int32();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.branding = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.eStopPressed = reader.bool();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.softwareVersion = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.friendlyChargerId = reader.int32();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.ctepCertificateNumber = reader.string();
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.powerLimitedHighUtilization = reader.bool();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.organizationName = reader.string();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.membershipValidation = charger_1.MembershipValidation.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 104) {
                        break;
                    }
                    message.otherEStopPressed = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxChargeRateKw: isSet(object.maxChargeRateKw)
                ? globalThis.Number(object.maxChargeRateKw)
                : isSet(object.max_charge_rate_kw)
                    ? globalThis.Number(object.max_charge_rate_kw)
                    : 0,
            pricing: isSet(object.pricing)
                ? money_1.PricingModel.fromJSON(object.pricing)
                : undefined,
            available: isSet(object.available)
                ? globalThis.Boolean(object.available)
                : false,
            timeOffsetFromUtcSeconds: isSet(object.timeOffsetFromUtcSeconds)
                ? globalThis.Number(object.timeOffsetFromUtcSeconds)
                : isSet(object.time_offset_from_utc_seconds)
                    ? globalThis.Number(object.time_offset_from_utc_seconds)
                    : 0,
            branding: isSet(object.branding)
                ? globalThis.String(object.branding)
                : "",
            eStopPressed: isSet(object.eStopPressed)
                ? globalThis.Boolean(object.eStopPressed)
                : isSet(object.e_stop_pressed)
                    ? globalThis.Boolean(object.e_stop_pressed)
                    : false,
            softwareVersion: isSet(object.softwareVersion)
                ? globalThis.String(object.softwareVersion)
                : isSet(object.software_version)
                    ? globalThis.String(object.software_version)
                    : "",
            friendlyChargerId: isSet(object.friendlyChargerId)
                ? globalThis.Number(object.friendlyChargerId)
                : isSet(object.friendly_charger_id)
                    ? globalThis.Number(object.friendly_charger_id)
                    : 0,
            ctepCertificateNumber: isSet(object.ctepCertificateNumber)
                ? globalThis.String(object.ctepCertificateNumber)
                : isSet(object.ctep_certificate_number)
                    ? globalThis.String(object.ctep_certificate_number)
                    : "",
            powerLimitedHighUtilization: isSet(object.powerLimitedHighUtilization)
                ? globalThis.Boolean(object.powerLimitedHighUtilization)
                : isSet(object.power_limited_high_utilization)
                    ? globalThis.Boolean(object.power_limited_high_utilization)
                    : false,
            organizationName: isSet(object.organizationName)
                ? globalThis.String(object.organizationName)
                : isSet(object.organization_name)
                    ? globalThis.String(object.organization_name)
                    : "",
            membershipValidation: isSet(object.membershipValidation)
                ? charger_1.MembershipValidation.fromJSON(object.membershipValidation)
                : isSet(object.membership_validation)
                    ? charger_1.MembershipValidation.fromJSON(object.membership_validation)
                    : undefined,
            otherEStopPressed: isSet(object.otherEStopPressed)
                ? globalThis.Boolean(object.otherEStopPressed)
                : isSet(object.other_e_stop_pressed)
                    ? globalThis.Boolean(object.other_e_stop_pressed)
                    : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.maxChargeRateKw !== 0) {
            obj.maxChargeRateKw = Math.round(message.maxChargeRateKw);
        }
        if (message.pricing !== undefined) {
            obj.pricing = money_1.PricingModel.toJSON(message.pricing);
        }
        if (message.available !== false) {
            obj.available = message.available;
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            obj.timeOffsetFromUtcSeconds = Math.round(message.timeOffsetFromUtcSeconds);
        }
        if (message.branding !== "") {
            obj.branding = message.branding;
        }
        if (message.eStopPressed !== false) {
            obj.eStopPressed = message.eStopPressed;
        }
        if (message.softwareVersion !== "") {
            obj.softwareVersion = message.softwareVersion;
        }
        if (message.friendlyChargerId !== 0) {
            obj.friendlyChargerId = Math.round(message.friendlyChargerId);
        }
        if (message.ctepCertificateNumber !== "") {
            obj.ctepCertificateNumber = message.ctepCertificateNumber;
        }
        if (message.powerLimitedHighUtilization !== false) {
            obj.powerLimitedHighUtilization = message.powerLimitedHighUtilization;
        }
        if (message.organizationName !== "") {
            obj.organizationName = message.organizationName;
        }
        if (message.membershipValidation !== undefined) {
            obj.membershipValidation = charger_1.MembershipValidation.toJSON(message.membershipValidation);
        }
        if (message.otherEStopPressed !== false) {
            obj.otherEStopPressed = message.otherEStopPressed;
        }
        return obj;
    },
    create(base) {
        return exports.ChargerState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargerState();
        message.maxChargeRateKw = object.maxChargeRateKw ?? 0;
        message.pricing =
            object.pricing !== undefined && object.pricing !== null
                ? money_1.PricingModel.fromPartial(object.pricing)
                : undefined;
        message.available = object.available ?? false;
        message.timeOffsetFromUtcSeconds = object.timeOffsetFromUtcSeconds ?? 0;
        message.branding = object.branding ?? "";
        message.eStopPressed = object.eStopPressed ?? false;
        message.softwareVersion = object.softwareVersion ?? "";
        message.friendlyChargerId = object.friendlyChargerId ?? 0;
        message.ctepCertificateNumber = object.ctepCertificateNumber ?? "";
        message.powerLimitedHighUtilization =
            object.powerLimitedHighUtilization ?? false;
        message.organizationName = object.organizationName ?? "";
        message.membershipValidation =
            object.membershipValidation !== undefined &&
                object.membershipValidation !== null
                ? charger_1.MembershipValidation.fromPartial(object.membershipValidation)
                : undefined;
        message.otherEStopPressed = object.otherEStopPressed ?? false;
        return message;
    },
};
function createBaseStatusUpdate() {
    return { portStates: [], chargerState: undefined };
}
exports.StatusUpdate = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.portStates) {
            exports.PortState.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.chargerState !== undefined) {
            exports.ChargerState.encode(message.chargerState, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStatusUpdate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.portStates.push(exports.PortState.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.chargerState = exports.ChargerState.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            portStates: globalThis.Array.isArray(object?.portStates)
                ? object.portStates.map((e) => exports.PortState.fromJSON(e))
                : globalThis.Array.isArray(object?.port_states)
                    ? object.port_states.map((e) => exports.PortState.fromJSON(e))
                    : [],
            chargerState: isSet(object.chargerState)
                ? exports.ChargerState.fromJSON(object.chargerState)
                : isSet(object.charger_state)
                    ? exports.ChargerState.fromJSON(object.charger_state)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.portStates?.length) {
            obj.portStates = message.portStates.map((e) => exports.PortState.toJSON(e));
        }
        if (message.chargerState !== undefined) {
            obj.chargerState = exports.ChargerState.toJSON(message.chargerState);
        }
        return obj;
    },
    create(base) {
        return exports.StatusUpdate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStatusUpdate();
        message.portStates =
            object.portStates?.map((e) => exports.PortState.fromPartial(e)) || [];
        message.chargerState =
            object.chargerState !== undefined && object.chargerState !== null
                ? exports.ChargerState.fromPartial(object.chargerState)
                : undefined;
        return message;
    },
};
function createBaseTransactionFinished() {
    return {
        connectorId: 0,
        kWhConsumed: 0,
        sessionDurationSeconds: 0,
        peakPowerKw: 0,
        totalCost: undefined,
        pricing: undefined,
        status: 0,
        costBreakdown: undefined,
        portType: 0,
        maxChargeRateKw: 0,
        transactionId: 0,
        faultCode: "",
        faultType: 0,
    };
}
exports.TransactionFinished = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.connectorId !== 0) {
            writer.uint32(8).uint32(message.connectorId);
        }
        if (message.kWhConsumed !== 0) {
            writer.uint32(21).float(message.kWhConsumed);
        }
        if (message.sessionDurationSeconds !== 0) {
            writer.uint32(24).uint32(message.sessionDurationSeconds);
        }
        if (message.peakPowerKw !== 0) {
            writer.uint32(37).float(message.peakPowerKw);
        }
        if (message.totalCost !== undefined) {
            money_1.Money.encode(message.totalCost, writer.uint32(42).fork()).join();
        }
        if (message.pricing !== undefined) {
            money_1.PricingModel.encode(message.pricing, writer.uint32(50).fork()).join();
        }
        if (message.status !== 0) {
            writer.uint32(56).int32(message.status);
        }
        if (message.costBreakdown !== undefined) {
            money_1.ChargeBreakdown.encode(message.costBreakdown, writer.uint32(66).fork()).join();
        }
        if (message.portType !== 0) {
            writer.uint32(72).int32(message.portType);
        }
        if (message.maxChargeRateKw !== 0) {
            writer.uint32(80).uint32(message.maxChargeRateKw);
        }
        if (message.transactionId !== 0) {
            writer.uint32(88).uint32(message.transactionId);
        }
        if (message.faultCode !== "") {
            writer.uint32(98).string(message.faultCode);
        }
        if (message.faultType !== 0) {
            writer.uint32(104).int32(message.faultType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransactionFinished();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.connectorId = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.kWhConsumed = reader.float();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.sessionDurationSeconds = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 37) {
                        break;
                    }
                    message.peakPowerKw = reader.float();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.totalCost = money_1.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.pricing = money_1.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.status = reader.int32();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.costBreakdown = money_1.ChargeBreakdown.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.portType = reader.int32();
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.maxChargeRateKw = reader.uint32();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.transactionId = reader.uint32();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.faultCode = reader.string();
                    continue;
                }
                case 13: {
                    if (tag !== 104) {
                        break;
                    }
                    message.faultType = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectorId: isSet(object.connectorId)
                ? globalThis.Number(object.connectorId)
                : isSet(object.connector_id)
                    ? globalThis.Number(object.connector_id)
                    : 0,
            kWhConsumed: isSet(object.kWhConsumed)
                ? globalThis.Number(object.kWhConsumed)
                : isSet(object.kWh_consumed)
                    ? globalThis.Number(object.kWh_consumed)
                    : 0,
            sessionDurationSeconds: isSet(object.sessionDurationSeconds)
                ? globalThis.Number(object.sessionDurationSeconds)
                : isSet(object.session_duration_seconds)
                    ? globalThis.Number(object.session_duration_seconds)
                    : 0,
            peakPowerKw: isSet(object.peakPowerKw)
                ? globalThis.Number(object.peakPowerKw)
                : isSet(object.peak_power_kw)
                    ? globalThis.Number(object.peak_power_kw)
                    : 0,
            totalCost: isSet(object.totalCost)
                ? money_1.Money.fromJSON(object.totalCost)
                : isSet(object.total_cost)
                    ? money_1.Money.fromJSON(object.total_cost)
                    : undefined,
            pricing: isSet(object.pricing)
                ? money_1.PricingModel.fromJSON(object.pricing)
                : undefined,
            status: isSet(object.status)
                ? transactionFinished_StatusFromJSON(object.status)
                : 0,
            costBreakdown: isSet(object.costBreakdown)
                ? money_1.ChargeBreakdown.fromJSON(object.costBreakdown)
                : isSet(object.cost_breakdown)
                    ? money_1.ChargeBreakdown.fromJSON(object.cost_breakdown)
                    : undefined,
            portType: isSet(object.portType)
                ? (0, charger_1.portTypeFromJSON)(object.portType)
                : isSet(object.port_type)
                    ? (0, charger_1.portTypeFromJSON)(object.port_type)
                    : 0,
            maxChargeRateKw: isSet(object.maxChargeRateKw)
                ? globalThis.Number(object.maxChargeRateKw)
                : isSet(object.max_charge_rate_kw)
                    ? globalThis.Number(object.max_charge_rate_kw)
                    : 0,
            transactionId: isSet(object.transactionId)
                ? globalThis.Number(object.transactionId)
                : isSet(object.transaction_id)
                    ? globalThis.Number(object.transaction_id)
                    : 0,
            faultCode: isSet(object.faultCode)
                ? globalThis.String(object.faultCode)
                : isSet(object.fault_code)
                    ? globalThis.String(object.fault_code)
                    : "",
            faultType: isSet(object.faultType)
                ? transactionFinished_FaultTypeFromJSON(object.faultType)
                : isSet(object.fault_type)
                    ? transactionFinished_FaultTypeFromJSON(object.fault_type)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectorId !== 0) {
            obj.connectorId = Math.round(message.connectorId);
        }
        if (message.kWhConsumed !== 0) {
            obj.kWhConsumed = message.kWhConsumed;
        }
        if (message.sessionDurationSeconds !== 0) {
            obj.sessionDurationSeconds = Math.round(message.sessionDurationSeconds);
        }
        if (message.peakPowerKw !== 0) {
            obj.peakPowerKw = message.peakPowerKw;
        }
        if (message.totalCost !== undefined) {
            obj.totalCost = money_1.Money.toJSON(message.totalCost);
        }
        if (message.pricing !== undefined) {
            obj.pricing = money_1.PricingModel.toJSON(message.pricing);
        }
        if (message.status !== 0) {
            obj.status = transactionFinished_StatusToJSON(message.status);
        }
        if (message.costBreakdown !== undefined) {
            obj.costBreakdown = money_1.ChargeBreakdown.toJSON(message.costBreakdown);
        }
        if (message.portType !== 0) {
            obj.portType = (0, charger_1.portTypeToJSON)(message.portType);
        }
        if (message.maxChargeRateKw !== 0) {
            obj.maxChargeRateKw = Math.round(message.maxChargeRateKw);
        }
        if (message.transactionId !== 0) {
            obj.transactionId = Math.round(message.transactionId);
        }
        if (message.faultCode !== "") {
            obj.faultCode = message.faultCode;
        }
        if (message.faultType !== 0) {
            obj.faultType = transactionFinished_FaultTypeToJSON(message.faultType);
        }
        return obj;
    },
    create(base) {
        return exports.TransactionFinished.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionFinished();
        message.connectorId = object.connectorId ?? 0;
        message.kWhConsumed = object.kWhConsumed ?? 0;
        message.sessionDurationSeconds = object.sessionDurationSeconds ?? 0;
        message.peakPowerKw = object.peakPowerKw ?? 0;
        message.totalCost =
            object.totalCost !== undefined && object.totalCost !== null
                ? money_1.Money.fromPartial(object.totalCost)
                : undefined;
        message.pricing =
            object.pricing !== undefined && object.pricing !== null
                ? money_1.PricingModel.fromPartial(object.pricing)
                : undefined;
        message.status = object.status ?? 0;
        message.costBreakdown =
            object.costBreakdown !== undefined && object.costBreakdown !== null
                ? money_1.ChargeBreakdown.fromPartial(object.costBreakdown)
                : undefined;
        message.portType = object.portType ?? 0;
        message.maxChargeRateKw = object.maxChargeRateKw ?? 0;
        message.transactionId = object.transactionId ?? 0;
        message.faultCode = object.faultCode ?? "";
        message.faultType = object.faultType ?? 0;
        return message;
    },
};
function createBaseConnectorPlugStatusChange() {
    return { connectorId: 0, pluggedIn: false, pluggedInTime: undefined };
}
exports.ConnectorPlugStatusChange = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.connectorId !== 0) {
            writer.uint32(8).uint32(message.connectorId);
        }
        if (message.pluggedIn !== false) {
            writer.uint32(16).bool(message.pluggedIn);
        }
        if (message.pluggedInTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.pluggedInTime), writer.uint32(82).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConnectorPlugStatusChange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.connectorId = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.pluggedIn = reader.bool();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.pluggedInTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectorId: isSet(object.connectorId)
                ? globalThis.Number(object.connectorId)
                : isSet(object.connector_id)
                    ? globalThis.Number(object.connector_id)
                    : 0,
            pluggedIn: isSet(object.pluggedIn)
                ? globalThis.Boolean(object.pluggedIn)
                : isSet(object.plugged_in)
                    ? globalThis.Boolean(object.plugged_in)
                    : false,
            pluggedInTime: isSet(object.pluggedInTime)
                ? fromJsonTimestamp(object.pluggedInTime)
                : isSet(object.plugged_in_time)
                    ? fromJsonTimestamp(object.plugged_in_time)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectorId !== 0) {
            obj.connectorId = Math.round(message.connectorId);
        }
        if (message.pluggedIn !== false) {
            obj.pluggedIn = message.pluggedIn;
        }
        if (message.pluggedInTime !== undefined) {
            obj.pluggedInTime = message.pluggedInTime.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.ConnectorPlugStatusChange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConnectorPlugStatusChange();
        message.connectorId = object.connectorId ?? 0;
        message.pluggedIn = object.pluggedIn ?? false;
        message.pluggedInTime = object.pluggedInTime ?? undefined;
        return message;
    },
};
function createBasePaymentError() {
    return { error: 0, cardPresentedTimestamp: undefined };
}
exports.PaymentError = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.error !== 0) {
            writer.uint32(8).int32(message.error);
        }
        if (message.cardPresentedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.cardPresentedTimestamp), writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePaymentError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.error = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.cardPresentedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            error: isSet(object.error) ? (0, money_1.cardPaymentErrorFromJSON)(object.error) : 0,
            cardPresentedTimestamp: isSet(object.cardPresentedTimestamp)
                ? fromJsonTimestamp(object.cardPresentedTimestamp)
                : isSet(object.card_presented_timestamp)
                    ? fromJsonTimestamp(object.card_presented_timestamp)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.error !== 0) {
            obj.error = (0, money_1.cardPaymentErrorToJSON)(message.error);
        }
        if (message.cardPresentedTimestamp !== undefined) {
            obj.cardPresentedTimestamp = message.cardPresentedTimestamp.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.PaymentError.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentError();
        message.error = object.error ?? 0;
        message.cardPresentedTimestamp = object.cardPresentedTimestamp ?? undefined;
        return message;
    },
};
function createBasePaymentAuthorized() {
    return { cardPresentedTimestamp: undefined };
}
exports.PaymentAuthorized = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.cardPresentedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.cardPresentedTimestamp), writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePaymentAuthorized();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.cardPresentedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            cardPresentedTimestamp: isSet(object.cardPresentedTimestamp)
                ? fromJsonTimestamp(object.cardPresentedTimestamp)
                : isSet(object.card_presented_timestamp)
                    ? fromJsonTimestamp(object.card_presented_timestamp)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cardPresentedTimestamp !== undefined) {
            obj.cardPresentedTimestamp = message.cardPresentedTimestamp.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.PaymentAuthorized.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentAuthorized();
        message.cardPresentedTimestamp = object.cardPresentedTimestamp ?? undefined;
        return message;
    },
};
function createBasePaymentPresented() {
    return { cardPresentedTimestamp: undefined };
}
exports.PaymentPresented = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.cardPresentedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.cardPresentedTimestamp), writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePaymentPresented();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.cardPresentedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            cardPresentedTimestamp: isSet(object.cardPresentedTimestamp)
                ? fromJsonTimestamp(object.cardPresentedTimestamp)
                : isSet(object.card_presented_timestamp)
                    ? fromJsonTimestamp(object.card_presented_timestamp)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cardPresentedTimestamp !== undefined) {
            obj.cardPresentedTimestamp = message.cardPresentedTimestamp.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.PaymentPresented.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentPresented();
        message.cardPresentedTimestamp = object.cardPresentedTimestamp ?? undefined;
        return message;
    },
};
function createBaseHeartbeatResponse() {
    return { sendTimeUtc: undefined };
}
exports.HeartbeatResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.sendTimeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.sendTimeUtc), writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeartbeatResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.sendTimeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sendTimeUtc: isSet(object.sendTimeUtc)
                ? fromJsonTimestamp(object.sendTimeUtc)
                : isSet(object.send_time_utc)
                    ? fromJsonTimestamp(object.send_time_utc)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sendTimeUtc !== undefined) {
            obj.sendTimeUtc = message.sendTimeUtc.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.HeartbeatResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHeartbeatResponse();
        message.sendTimeUtc = object.sendTimeUtc ?? undefined;
        return message;
    },
};
function createBaseGetResourceReport() {
    return {};
}
exports.GetResourceReport = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetResourceReport();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetResourceReport.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetResourceReport();
        return message;
    },
};
function createBaseSetUiConfig() {
    return { uiConfig: undefined };
}
exports.SetUiConfig = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.uiConfig !== undefined) {
            charger_1.UiConfig.encode(message.uiConfig, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetUiConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.uiConfig = charger_1.UiConfig.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            uiConfig: isSet(object.uiConfig)
                ? charger_1.UiConfig.fromJSON(object.uiConfig)
                : isSet(object.ui_config)
                    ? charger_1.UiConfig.fromJSON(object.ui_config)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.uiConfig !== undefined) {
            obj.uiConfig = charger_1.UiConfig.toJSON(message.uiConfig);
        }
        return obj;
    },
    create(base) {
        return exports.SetUiConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetUiConfig();
        message.uiConfig =
            object.uiConfig !== undefined && object.uiConfig !== null
                ? charger_1.UiConfig.fromPartial(object.uiConfig)
                : undefined;
        return message;
    },
};
function createBasePricingChangedSinceLastSession() {
    return {};
}
exports.PricingChangedSinceLastSession = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePricingChangedSinceLastSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.PricingChangedSinceLastSession.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePricingChangedSinceLastSession();
        return message;
    },
};
function createBaseCtepParameter() {
    return { parameterId: "", value: "", timestampUtc: undefined };
}
exports.CtepParameter = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.parameterId !== "") {
            writer.uint32(10).string(message.parameterId);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        if (message.timestampUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timestampUtc), writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCtepParameter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.parameterId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.timestampUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            parameterId: isSet(object.parameterId)
                ? globalThis.String(object.parameterId)
                : isSet(object.parameter_id)
                    ? globalThis.String(object.parameter_id)
                    : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
            timestampUtc: isSet(object.timestampUtc)
                ? fromJsonTimestamp(object.timestampUtc)
                : isSet(object.timestamp_utc)
                    ? fromJsonTimestamp(object.timestamp_utc)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.parameterId !== "") {
            obj.parameterId = message.parameterId;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        if (message.timestampUtc !== undefined) {
            obj.timestampUtc = message.timestampUtc.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.CtepParameter.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCtepParameter();
        message.parameterId = object.parameterId ?? "";
        message.value = object.value ?? "";
        message.timestampUtc = object.timestampUtc ?? undefined;
        return message;
    },
};
function createBaseCtepParameterLog() {
    return { logEntries: [] };
}
exports.CtepParameterLog = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.logEntries) {
            exports.CtepParameter.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCtepParameterLog();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.logEntries.push(exports.CtepParameter.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            logEntries: globalThis.Array.isArray(object?.logEntries)
                ? object.logEntries.map((e) => exports.CtepParameter.fromJSON(e))
                : globalThis.Array.isArray(object?.log_entries)
                    ? object.log_entries.map((e) => exports.CtepParameter.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.logEntries?.length) {
            obj.logEntries = message.logEntries.map((e) => exports.CtepParameter.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.CtepParameterLog.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCtepParameterLog();
        message.logEntries =
            object.logEntries?.map((e) => exports.CtepParameter.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMessageToUI() {
    return {
        statusUpdate: undefined,
        transactionFinished: undefined,
        connectorStatusChange: undefined,
        paymentError: undefined,
        paymentAuthorized: undefined,
        paymentPresented: undefined,
        heartbeatResponse: undefined,
        getResourceReport: undefined,
        pricingChangedSinceLastSession: undefined,
        setUiConfig: undefined,
        membershipPresented: undefined,
        ctepParameterLog: undefined,
    };
}
exports.MessageToUI = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.statusUpdate !== undefined) {
            exports.StatusUpdate.encode(message.statusUpdate, writer.uint32(10).fork()).join();
        }
        if (message.transactionFinished !== undefined) {
            exports.TransactionFinished.encode(message.transactionFinished, writer.uint32(18).fork()).join();
        }
        if (message.connectorStatusChange !== undefined) {
            exports.ConnectorPlugStatusChange.encode(message.connectorStatusChange, writer.uint32(26).fork()).join();
        }
        if (message.paymentError !== undefined) {
            exports.PaymentError.encode(message.paymentError, writer.uint32(34).fork()).join();
        }
        if (message.paymentAuthorized !== undefined) {
            exports.PaymentAuthorized.encode(message.paymentAuthorized, writer.uint32(42).fork()).join();
        }
        if (message.paymentPresented !== undefined) {
            exports.PaymentPresented.encode(message.paymentPresented, writer.uint32(50).fork()).join();
        }
        if (message.heartbeatResponse !== undefined) {
            exports.HeartbeatResponse.encode(message.heartbeatResponse, writer.uint32(58).fork()).join();
        }
        if (message.getResourceReport !== undefined) {
            exports.GetResourceReport.encode(message.getResourceReport, writer.uint32(66).fork()).join();
        }
        if (message.pricingChangedSinceLastSession !== undefined) {
            exports.PricingChangedSinceLastSession.encode(message.pricingChangedSinceLastSession, writer.uint32(74).fork()).join();
        }
        if (message.setUiConfig !== undefined) {
            exports.SetUiConfig.encode(message.setUiConfig, writer.uint32(82).fork()).join();
        }
        if (message.membershipPresented !== undefined) {
            exports.MembershipState.encode(message.membershipPresented, writer.uint32(90).fork()).join();
        }
        if (message.ctepParameterLog !== undefined) {
            exports.CtepParameterLog.encode(message.ctepParameterLog, writer.uint32(98).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMessageToUI();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.statusUpdate = exports.StatusUpdate.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.transactionFinished = exports.TransactionFinished.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.connectorStatusChange = exports.ConnectorPlugStatusChange.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.paymentError = exports.PaymentError.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.paymentAuthorized = exports.PaymentAuthorized.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.paymentPresented = exports.PaymentPresented.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.heartbeatResponse = exports.HeartbeatResponse.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.getResourceReport = exports.GetResourceReport.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.pricingChangedSinceLastSession =
                        exports.PricingChangedSinceLastSession.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.setUiConfig = exports.SetUiConfig.decode(reader, reader.uint32());
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.membershipPresented = exports.MembershipState.decode(reader, reader.uint32());
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.ctepParameterLog = exports.CtepParameterLog.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            statusUpdate: isSet(object.statusUpdate)
                ? exports.StatusUpdate.fromJSON(object.statusUpdate)
                : isSet(object.status_update)
                    ? exports.StatusUpdate.fromJSON(object.status_update)
                    : undefined,
            transactionFinished: isSet(object.transactionFinished)
                ? exports.TransactionFinished.fromJSON(object.transactionFinished)
                : isSet(object.transaction_finished)
                    ? exports.TransactionFinished.fromJSON(object.transaction_finished)
                    : undefined,
            connectorStatusChange: isSet(object.connectorStatusChange)
                ? exports.ConnectorPlugStatusChange.fromJSON(object.connectorStatusChange)
                : isSet(object.connector_status_change)
                    ? exports.ConnectorPlugStatusChange.fromJSON(object.connector_status_change)
                    : undefined,
            paymentError: isSet(object.paymentError)
                ? exports.PaymentError.fromJSON(object.paymentError)
                : isSet(object.payment_error)
                    ? exports.PaymentError.fromJSON(object.payment_error)
                    : undefined,
            paymentAuthorized: isSet(object.paymentAuthorized)
                ? exports.PaymentAuthorized.fromJSON(object.paymentAuthorized)
                : isSet(object.payment_authorized)
                    ? exports.PaymentAuthorized.fromJSON(object.payment_authorized)
                    : undefined,
            paymentPresented: isSet(object.paymentPresented)
                ? exports.PaymentPresented.fromJSON(object.paymentPresented)
                : isSet(object.payment_presented)
                    ? exports.PaymentPresented.fromJSON(object.payment_presented)
                    : undefined,
            heartbeatResponse: isSet(object.heartbeatResponse)
                ? exports.HeartbeatResponse.fromJSON(object.heartbeatResponse)
                : isSet(object.heartbeat_response)
                    ? exports.HeartbeatResponse.fromJSON(object.heartbeat_response)
                    : undefined,
            getResourceReport: isSet(object.getResourceReport)
                ? exports.GetResourceReport.fromJSON(object.getResourceReport)
                : isSet(object.get_resource_report)
                    ? exports.GetResourceReport.fromJSON(object.get_resource_report)
                    : undefined,
            pricingChangedSinceLastSession: isSet(object.pricingChangedSinceLastSession)
                ? exports.PricingChangedSinceLastSession.fromJSON(object.pricingChangedSinceLastSession)
                : isSet(object.pricing_changed_since_last_session)
                    ? exports.PricingChangedSinceLastSession.fromJSON(object.pricing_changed_since_last_session)
                    : undefined,
            setUiConfig: isSet(object.setUiConfig)
                ? exports.SetUiConfig.fromJSON(object.setUiConfig)
                : isSet(object.set_ui_config)
                    ? exports.SetUiConfig.fromJSON(object.set_ui_config)
                    : undefined,
            membershipPresented: isSet(object.membershipPresented)
                ? exports.MembershipState.fromJSON(object.membershipPresented)
                : isSet(object.membership_presented)
                    ? exports.MembershipState.fromJSON(object.membership_presented)
                    : undefined,
            ctepParameterLog: isSet(object.ctepParameterLog)
                ? exports.CtepParameterLog.fromJSON(object.ctepParameterLog)
                : isSet(object.ctep_parameter_log)
                    ? exports.CtepParameterLog.fromJSON(object.ctep_parameter_log)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.statusUpdate !== undefined) {
            obj.statusUpdate = exports.StatusUpdate.toJSON(message.statusUpdate);
        }
        if (message.transactionFinished !== undefined) {
            obj.transactionFinished = exports.TransactionFinished.toJSON(message.transactionFinished);
        }
        if (message.connectorStatusChange !== undefined) {
            obj.connectorStatusChange = exports.ConnectorPlugStatusChange.toJSON(message.connectorStatusChange);
        }
        if (message.paymentError !== undefined) {
            obj.paymentError = exports.PaymentError.toJSON(message.paymentError);
        }
        if (message.paymentAuthorized !== undefined) {
            obj.paymentAuthorized = exports.PaymentAuthorized.toJSON(message.paymentAuthorized);
        }
        if (message.paymentPresented !== undefined) {
            obj.paymentPresented = exports.PaymentPresented.toJSON(message.paymentPresented);
        }
        if (message.heartbeatResponse !== undefined) {
            obj.heartbeatResponse = exports.HeartbeatResponse.toJSON(message.heartbeatResponse);
        }
        if (message.getResourceReport !== undefined) {
            obj.getResourceReport = exports.GetResourceReport.toJSON(message.getResourceReport);
        }
        if (message.pricingChangedSinceLastSession !== undefined) {
            obj.pricingChangedSinceLastSession =
                exports.PricingChangedSinceLastSession.toJSON(message.pricingChangedSinceLastSession);
        }
        if (message.setUiConfig !== undefined) {
            obj.setUiConfig = exports.SetUiConfig.toJSON(message.setUiConfig);
        }
        if (message.membershipPresented !== undefined) {
            obj.membershipPresented = exports.MembershipState.toJSON(message.membershipPresented);
        }
        if (message.ctepParameterLog !== undefined) {
            obj.ctepParameterLog = exports.CtepParameterLog.toJSON(message.ctepParameterLog);
        }
        return obj;
    },
    create(base) {
        return exports.MessageToUI.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMessageToUI();
        message.statusUpdate =
            object.statusUpdate !== undefined && object.statusUpdate !== null
                ? exports.StatusUpdate.fromPartial(object.statusUpdate)
                : undefined;
        message.transactionFinished =
            object.transactionFinished !== undefined &&
                object.transactionFinished !== null
                ? exports.TransactionFinished.fromPartial(object.transactionFinished)
                : undefined;
        message.connectorStatusChange =
            object.connectorStatusChange !== undefined &&
                object.connectorStatusChange !== null
                ? exports.ConnectorPlugStatusChange.fromPartial(object.connectorStatusChange)
                : undefined;
        message.paymentError =
            object.paymentError !== undefined && object.paymentError !== null
                ? exports.PaymentError.fromPartial(object.paymentError)
                : undefined;
        message.paymentAuthorized =
            object.paymentAuthorized !== undefined &&
                object.paymentAuthorized !== null
                ? exports.PaymentAuthorized.fromPartial(object.paymentAuthorized)
                : undefined;
        message.paymentPresented =
            object.paymentPresented !== undefined && object.paymentPresented !== null
                ? exports.PaymentPresented.fromPartial(object.paymentPresented)
                : undefined;
        message.heartbeatResponse =
            object.heartbeatResponse !== undefined &&
                object.heartbeatResponse !== null
                ? exports.HeartbeatResponse.fromPartial(object.heartbeatResponse)
                : undefined;
        message.getResourceReport =
            object.getResourceReport !== undefined &&
                object.getResourceReport !== null
                ? exports.GetResourceReport.fromPartial(object.getResourceReport)
                : undefined;
        message.pricingChangedSinceLastSession =
            object.pricingChangedSinceLastSession !== undefined &&
                object.pricingChangedSinceLastSession !== null
                ? exports.PricingChangedSinceLastSession.fromPartial(object.pricingChangedSinceLastSession)
                : undefined;
        message.setUiConfig =
            object.setUiConfig !== undefined && object.setUiConfig !== null
                ? exports.SetUiConfig.fromPartial(object.setUiConfig)
                : undefined;
        message.membershipPresented =
            object.membershipPresented !== undefined &&
                object.membershipPresented !== null
                ? exports.MembershipState.fromPartial(object.membershipPresented)
                : undefined;
        message.ctepParameterLog =
            object.ctepParameterLog !== undefined && object.ctepParameterLog !== null
                ? exports.CtepParameterLog.fromPartial(object.ctepParameterLog)
                : undefined;
        return message;
    },
};
function createBaseStopCharging() {
    return { connectorId: 0 };
}
exports.StopCharging = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.connectorId !== 0) {
            writer.uint32(8).uint32(message.connectorId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStopCharging();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.connectorId = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectorId: isSet(object.connectorId)
                ? globalThis.Number(object.connectorId)
                : isSet(object.connector_id)
                    ? globalThis.Number(object.connector_id)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectorId !== 0) {
            obj.connectorId = Math.round(message.connectorId);
        }
        return obj;
    },
    create(base) {
        return exports.StopCharging.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStopCharging();
        message.connectorId = object.connectorId ?? 0;
        return message;
    },
};
function createBaseAssignMembership() {
    return { connectorId: 0 };
}
exports.AssignMembership = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.connectorId !== 0) {
            writer.uint32(8).uint32(message.connectorId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAssignMembership();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.connectorId = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectorId: isSet(object.connectorId)
                ? globalThis.Number(object.connectorId)
                : isSet(object.connector_id)
                    ? globalThis.Number(object.connector_id)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectorId !== 0) {
            obj.connectorId = Math.round(message.connectorId);
        }
        return obj;
    },
    create(base) {
        return exports.AssignMembership.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAssignMembership();
        message.connectorId = object.connectorId ?? 0;
        return message;
    },
};
function createBaseAssignPayment() {
    return { connectorId: 0 };
}
exports.AssignPayment = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.connectorId !== 0) {
            writer.uint32(8).uint32(message.connectorId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAssignPayment();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.connectorId = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectorId: isSet(object.connectorId)
                ? globalThis.Number(object.connectorId)
                : isSet(object.connector_id)
                    ? globalThis.Number(object.connector_id)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectorId !== 0) {
            obj.connectorId = Math.round(message.connectorId);
        }
        return obj;
    },
    create(base) {
        return exports.AssignPayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAssignPayment();
        message.connectorId = object.connectorId ?? 0;
        return message;
    },
};
function createBaseProblemReported() {
    return { problemDescription: "" };
}
exports.ProblemReported = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.problemDescription !== "") {
            writer.uint32(10).string(message.problemDescription);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProblemReported();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.problemDescription = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            problemDescription: isSet(object.problemDescription)
                ? globalThis.String(object.problemDescription)
                : isSet(object.problem_description)
                    ? globalThis.String(object.problem_description)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.problemDescription !== "") {
            obj.problemDescription = message.problemDescription;
        }
        return obj;
    },
    create(base) {
        return exports.ProblemReported.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProblemReported();
        message.problemDescription = object.problemDescription ?? "";
        return message;
    },
};
function createBaseCancelTransaction() {
    return { connectorId: 0 };
}
exports.CancelTransaction = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.connectorId !== 0) {
            writer.uint32(8).uint32(message.connectorId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCancelTransaction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.connectorId = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectorId: isSet(object.connectorId)
                ? globalThis.Number(object.connectorId)
                : isSet(object.connector_id)
                    ? globalThis.Number(object.connector_id)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectorId !== 0) {
            obj.connectorId = Math.round(message.connectorId);
        }
        return obj;
    },
    create(base) {
        return exports.CancelTransaction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCancelTransaction();
        message.connectorId = object.connectorId ?? 0;
        return message;
    },
};
function createBaseGenerateReceipt() {
    return { transactionId: 0, emailAddress: "" };
}
exports.GenerateReceipt = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.transactionId !== 0) {
            writer.uint32(8).uint32(message.transactionId);
        }
        if (message.emailAddress !== "") {
            writer.uint32(18).string(message.emailAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenerateReceipt();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.transactionId = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.emailAddress = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            transactionId: isSet(object.transactionId)
                ? globalThis.Number(object.transactionId)
                : isSet(object.transaction_id)
                    ? globalThis.Number(object.transaction_id)
                    : 0,
            emailAddress: isSet(object.emailAddress)
                ? globalThis.String(object.emailAddress)
                : isSet(object.email_address)
                    ? globalThis.String(object.email_address)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.transactionId !== 0) {
            obj.transactionId = Math.round(message.transactionId);
        }
        if (message.emailAddress !== "") {
            obj.emailAddress = message.emailAddress;
        }
        return obj;
    },
    create(base) {
        return exports.GenerateReceipt.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGenerateReceipt();
        message.transactionId = object.transactionId ?? 0;
        message.emailAddress = object.emailAddress ?? "";
        return message;
    },
};
function createBaseSendLog() {
    return { severity: 0, message: "" };
}
exports.SendLog = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.severity !== 0) {
            writer.uint32(8).int32(message.severity);
        }
        if (message.message !== "") {
            writer.uint32(18).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendLog();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.severity = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            severity: isSet(object.severity)
                ? logSeverityFromJSON(object.severity)
                : 0,
            message: isSet(object.message) ? globalThis.String(object.message) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.severity !== 0) {
            obj.severity = logSeverityToJSON(message.severity);
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return exports.SendLog.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendLog();
        message.severity = object.severity ?? 0;
        message.message = object.message ?? "";
        return message;
    },
};
function createBaseHeartbeat() {
    return { timeUtc: undefined, measuredRoundTripMs: 0 };
}
exports.Heartbeat = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.timeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timeUtc), writer.uint32(10).fork()).join();
        }
        if (message.measuredRoundTripMs !== 0) {
            writer.uint32(16).uint32(message.measuredRoundTripMs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeartbeat();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.timeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.measuredRoundTripMs = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            timeUtc: isSet(object.timeUtc)
                ? fromJsonTimestamp(object.timeUtc)
                : isSet(object.time_utc)
                    ? fromJsonTimestamp(object.time_utc)
                    : undefined,
            measuredRoundTripMs: isSet(object.measuredRoundTripMs)
                ? globalThis.Number(object.measuredRoundTripMs)
                : isSet(object.measured_round_trip_ms)
                    ? globalThis.Number(object.measured_round_trip_ms)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.timeUtc !== undefined) {
            obj.timeUtc = message.timeUtc.toISOString();
        }
        if (message.measuredRoundTripMs !== 0) {
            obj.measuredRoundTripMs = Math.round(message.measuredRoundTripMs);
        }
        return obj;
    },
    create(base) {
        return exports.Heartbeat.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHeartbeat();
        message.timeUtc = object.timeUtc ?? undefined;
        message.measuredRoundTripMs = object.measuredRoundTripMs ?? 0;
        return message;
    },
};
function createBaseFeedbackProvided() {
    return { rating: 0, feedback: "", connectorId: 0, reportedIssues: [] };
}
exports.FeedbackProvided = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.rating !== 0) {
            writer.uint32(8).uint32(message.rating);
        }
        if (message.feedback !== "") {
            writer.uint32(18).string(message.feedback);
        }
        if (message.connectorId !== 0) {
            writer.uint32(24).uint32(message.connectorId);
        }
        writer.uint32(34).fork();
        for (const v of message.reportedIssues) {
            writer.int32(v);
        }
        writer.join();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeedbackProvided();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.rating = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.feedback = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.connectorId = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag === 32) {
                        message.reportedIssues.push(reader.int32());
                        continue;
                    }
                    if (tag === 34) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.reportedIssues.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rating: isSet(object.rating) ? globalThis.Number(object.rating) : 0,
            feedback: isSet(object.feedback)
                ? globalThis.String(object.feedback)
                : "",
            connectorId: isSet(object.connectorId)
                ? globalThis.Number(object.connectorId)
                : isSet(object.connector_id)
                    ? globalThis.Number(object.connector_id)
                    : 0,
            reportedIssues: globalThis.Array.isArray(object?.reportedIssues)
                ? object.reportedIssues.map((e) => (0, charger_1.reportedFeedbackIssueFromJSON)(e))
                : globalThis.Array.isArray(object?.reported_issues)
                    ? object.reported_issues.map((e) => (0, charger_1.reportedFeedbackIssueFromJSON)(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rating !== 0) {
            obj.rating = Math.round(message.rating);
        }
        if (message.feedback !== "") {
            obj.feedback = message.feedback;
        }
        if (message.connectorId !== 0) {
            obj.connectorId = Math.round(message.connectorId);
        }
        if (message.reportedIssues?.length) {
            obj.reportedIssues = message.reportedIssues.map((e) => (0, charger_1.reportedFeedbackIssueToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.FeedbackProvided.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeedbackProvided();
        message.rating = object.rating ?? 0;
        message.feedback = object.feedback ?? "";
        message.connectorId = object.connectorId ?? 0;
        message.reportedIssues = object.reportedIssues?.map((e) => e) || [];
        return message;
    },
};
function createBaseResourceStat() {
    return { resource: "", value: "", nominal: false };
}
exports.ResourceStat = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.resource !== "") {
            writer.uint32(10).string(message.resource);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        if (message.nominal !== false) {
            writer.uint32(24).bool(message.nominal);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResourceStat();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.resource = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.nominal = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            resource: isSet(object.resource)
                ? globalThis.String(object.resource)
                : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
            nominal: isSet(object.nominal)
                ? globalThis.Boolean(object.nominal)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.resource !== "") {
            obj.resource = message.resource;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        if (message.nominal !== false) {
            obj.nominal = message.nominal;
        }
        return obj;
    },
    create(base) {
        return exports.ResourceStat.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseResourceStat();
        message.resource = object.resource ?? "";
        message.value = object.value ?? "";
        message.nominal = object.nominal ?? false;
        return message;
    },
};
function createBaseResourceReport() {
    return { timestamp: "", resourceStats: [] };
}
exports.ResourceReport = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.timestamp !== "") {
            writer.uint32(10).string(message.timestamp);
        }
        for (const v of message.resourceStats) {
            exports.ResourceStat.encode(v, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResourceReport();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.timestamp = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.resourceStats.push(exports.ResourceStat.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            timestamp: isSet(object.timestamp)
                ? globalThis.String(object.timestamp)
                : "",
            resourceStats: globalThis.Array.isArray(object?.resourceStats)
                ? object.resourceStats.map((e) => exports.ResourceStat.fromJSON(e))
                : globalThis.Array.isArray(object?.resource_stats)
                    ? object.resource_stats.map((e) => exports.ResourceStat.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.timestamp !== "") {
            obj.timestamp = message.timestamp;
        }
        if (message.resourceStats?.length) {
            obj.resourceStats = message.resourceStats.map((e) => exports.ResourceStat.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ResourceReport.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseResourceReport();
        message.timestamp = object.timestamp ?? "";
        message.resourceStats =
            object.resourceStats?.map((e) => exports.ResourceStat.fromPartial(e)) || [];
        return message;
    },
};
function createBaseValidateMembership() {
    return { requestTimestamp: undefined, membershipIdentifier: "" };
}
exports.ValidateMembership = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.requestTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.requestTimestamp), writer.uint32(10).fork()).join();
        }
        if (message.membershipIdentifier !== "") {
            writer.uint32(18).string(message.membershipIdentifier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidateMembership();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.requestTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.membershipIdentifier = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            requestTimestamp: isSet(object.requestTimestamp)
                ? fromJsonTimestamp(object.requestTimestamp)
                : isSet(object.request_timestamp)
                    ? fromJsonTimestamp(object.request_timestamp)
                    : undefined,
            membershipIdentifier: isSet(object.membershipIdentifier)
                ? globalThis.String(object.membershipIdentifier)
                : isSet(object.membership_identifier)
                    ? globalThis.String(object.membership_identifier)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.requestTimestamp !== undefined) {
            obj.requestTimestamp = message.requestTimestamp.toISOString();
        }
        if (message.membershipIdentifier !== "") {
            obj.membershipIdentifier = message.membershipIdentifier;
        }
        return obj;
    },
    create(base) {
        return exports.ValidateMembership.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValidateMembership();
        message.requestTimestamp = object.requestTimestamp ?? undefined;
        message.membershipIdentifier = object.membershipIdentifier ?? "";
        return message;
    },
};
function createBaseGetCtepParameterLog() {
    return {};
}
exports.GetCtepParameterLog = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetCtepParameterLog();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetCtepParameterLog.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetCtepParameterLog();
        return message;
    },
};
function createBaseUseMembershipPresentedAsPayment() {
    return { connectorId: 0 };
}
exports.UseMembershipPresentedAsPayment = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.connectorId !== 0) {
            writer.uint32(8).uint32(message.connectorId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUseMembershipPresentedAsPayment();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.connectorId = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectorId: isSet(object.connectorId)
                ? globalThis.Number(object.connectorId)
                : isSet(object.connector_id)
                    ? globalThis.Number(object.connector_id)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectorId !== 0) {
            obj.connectorId = Math.round(message.connectorId);
        }
        return obj;
    },
    create(base) {
        return exports.UseMembershipPresentedAsPayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUseMembershipPresentedAsPayment();
        message.connectorId = object.connectorId ?? 0;
        return message;
    },
};
function createBaseMessageFromUI() {
    return {
        stopCharging: undefined,
        assignPayment: undefined,
        problemReported: undefined,
        cancelTransaction: undefined,
        generateReceipt: undefined,
        sendLog: undefined,
        heartbeat: undefined,
        feedback: undefined,
        resourceReport: undefined,
        validateMembership: undefined,
        assignMembership: undefined,
        getCtepParameterLog: undefined,
        useMembershipPresentedAsPayment: undefined,
    };
}
exports.MessageFromUI = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.stopCharging !== undefined) {
            exports.StopCharging.encode(message.stopCharging, writer.uint32(10).fork()).join();
        }
        if (message.assignPayment !== undefined) {
            exports.AssignPayment.encode(message.assignPayment, writer.uint32(18).fork()).join();
        }
        if (message.problemReported !== undefined) {
            exports.ProblemReported.encode(message.problemReported, writer.uint32(26).fork()).join();
        }
        if (message.cancelTransaction !== undefined) {
            exports.CancelTransaction.encode(message.cancelTransaction, writer.uint32(34).fork()).join();
        }
        if (message.generateReceipt !== undefined) {
            exports.GenerateReceipt.encode(message.generateReceipt, writer.uint32(42).fork()).join();
        }
        if (message.sendLog !== undefined) {
            exports.SendLog.encode(message.sendLog, writer.uint32(50).fork()).join();
        }
        if (message.heartbeat !== undefined) {
            exports.Heartbeat.encode(message.heartbeat, writer.uint32(58).fork()).join();
        }
        if (message.feedback !== undefined) {
            exports.FeedbackProvided.encode(message.feedback, writer.uint32(66).fork()).join();
        }
        if (message.resourceReport !== undefined) {
            exports.ResourceReport.encode(message.resourceReport, writer.uint32(74).fork()).join();
        }
        if (message.validateMembership !== undefined) {
            exports.ValidateMembership.encode(message.validateMembership, writer.uint32(82).fork()).join();
        }
        if (message.assignMembership !== undefined) {
            exports.AssignMembership.encode(message.assignMembership, writer.uint32(90).fork()).join();
        }
        if (message.getCtepParameterLog !== undefined) {
            exports.GetCtepParameterLog.encode(message.getCtepParameterLog, writer.uint32(98).fork()).join();
        }
        if (message.useMembershipPresentedAsPayment !== undefined) {
            exports.UseMembershipPresentedAsPayment.encode(message.useMembershipPresentedAsPayment, writer.uint32(106).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMessageFromUI();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.stopCharging = exports.StopCharging.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.assignPayment = exports.AssignPayment.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.problemReported = exports.ProblemReported.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.cancelTransaction = exports.CancelTransaction.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.generateReceipt = exports.GenerateReceipt.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.sendLog = exports.SendLog.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.heartbeat = exports.Heartbeat.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.feedback = exports.FeedbackProvided.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.resourceReport = exports.ResourceReport.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.validateMembership = exports.ValidateMembership.decode(reader, reader.uint32());
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.assignMembership = exports.AssignMembership.decode(reader, reader.uint32());
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.getCtepParameterLog = exports.GetCtepParameterLog.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.useMembershipPresentedAsPayment =
                        exports.UseMembershipPresentedAsPayment.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            stopCharging: isSet(object.stopCharging)
                ? exports.StopCharging.fromJSON(object.stopCharging)
                : isSet(object.stop_charging)
                    ? exports.StopCharging.fromJSON(object.stop_charging)
                    : undefined,
            assignPayment: isSet(object.assignPayment)
                ? exports.AssignPayment.fromJSON(object.assignPayment)
                : isSet(object.assign_payment)
                    ? exports.AssignPayment.fromJSON(object.assign_payment)
                    : undefined,
            problemReported: isSet(object.problemReported)
                ? exports.ProblemReported.fromJSON(object.problemReported)
                : isSet(object.problem_reported)
                    ? exports.ProblemReported.fromJSON(object.problem_reported)
                    : undefined,
            cancelTransaction: isSet(object.cancelTransaction)
                ? exports.CancelTransaction.fromJSON(object.cancelTransaction)
                : isSet(object.cancel_transaction)
                    ? exports.CancelTransaction.fromJSON(object.cancel_transaction)
                    : undefined,
            generateReceipt: isSet(object.generateReceipt)
                ? exports.GenerateReceipt.fromJSON(object.generateReceipt)
                : isSet(object.generate_receipt)
                    ? exports.GenerateReceipt.fromJSON(object.generate_receipt)
                    : undefined,
            sendLog: isSet(object.sendLog)
                ? exports.SendLog.fromJSON(object.sendLog)
                : isSet(object.send_log)
                    ? exports.SendLog.fromJSON(object.send_log)
                    : undefined,
            heartbeat: isSet(object.heartbeat)
                ? exports.Heartbeat.fromJSON(object.heartbeat)
                : undefined,
            feedback: isSet(object.feedback)
                ? exports.FeedbackProvided.fromJSON(object.feedback)
                : undefined,
            resourceReport: isSet(object.resourceReport)
                ? exports.ResourceReport.fromJSON(object.resourceReport)
                : isSet(object.resource_report)
                    ? exports.ResourceReport.fromJSON(object.resource_report)
                    : undefined,
            validateMembership: isSet(object.validateMembership)
                ? exports.ValidateMembership.fromJSON(object.validateMembership)
                : isSet(object.validate_membership)
                    ? exports.ValidateMembership.fromJSON(object.validate_membership)
                    : undefined,
            assignMembership: isSet(object.assignMembership)
                ? exports.AssignMembership.fromJSON(object.assignMembership)
                : isSet(object.assign_membership)
                    ? exports.AssignMembership.fromJSON(object.assign_membership)
                    : undefined,
            getCtepParameterLog: isSet(object.getCtepParameterLog)
                ? exports.GetCtepParameterLog.fromJSON(object.getCtepParameterLog)
                : isSet(object.get_ctep_parameter_log)
                    ? exports.GetCtepParameterLog.fromJSON(object.get_ctep_parameter_log)
                    : undefined,
            useMembershipPresentedAsPayment: isSet(object.useMembershipPresentedAsPayment)
                ? exports.UseMembershipPresentedAsPayment.fromJSON(object.useMembershipPresentedAsPayment)
                : isSet(object.use_membership_presented_as_payment)
                    ? exports.UseMembershipPresentedAsPayment.fromJSON(object.use_membership_presented_as_payment)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.stopCharging !== undefined) {
            obj.stopCharging = exports.StopCharging.toJSON(message.stopCharging);
        }
        if (message.assignPayment !== undefined) {
            obj.assignPayment = exports.AssignPayment.toJSON(message.assignPayment);
        }
        if (message.problemReported !== undefined) {
            obj.problemReported = exports.ProblemReported.toJSON(message.problemReported);
        }
        if (message.cancelTransaction !== undefined) {
            obj.cancelTransaction = exports.CancelTransaction.toJSON(message.cancelTransaction);
        }
        if (message.generateReceipt !== undefined) {
            obj.generateReceipt = exports.GenerateReceipt.toJSON(message.generateReceipt);
        }
        if (message.sendLog !== undefined) {
            obj.sendLog = exports.SendLog.toJSON(message.sendLog);
        }
        if (message.heartbeat !== undefined) {
            obj.heartbeat = exports.Heartbeat.toJSON(message.heartbeat);
        }
        if (message.feedback !== undefined) {
            obj.feedback = exports.FeedbackProvided.toJSON(message.feedback);
        }
        if (message.resourceReport !== undefined) {
            obj.resourceReport = exports.ResourceReport.toJSON(message.resourceReport);
        }
        if (message.validateMembership !== undefined) {
            obj.validateMembership = exports.ValidateMembership.toJSON(message.validateMembership);
        }
        if (message.assignMembership !== undefined) {
            obj.assignMembership = exports.AssignMembership.toJSON(message.assignMembership);
        }
        if (message.getCtepParameterLog !== undefined) {
            obj.getCtepParameterLog = exports.GetCtepParameterLog.toJSON(message.getCtepParameterLog);
        }
        if (message.useMembershipPresentedAsPayment !== undefined) {
            obj.useMembershipPresentedAsPayment =
                exports.UseMembershipPresentedAsPayment.toJSON(message.useMembershipPresentedAsPayment);
        }
        return obj;
    },
    create(base) {
        return exports.MessageFromUI.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMessageFromUI();
        message.stopCharging =
            object.stopCharging !== undefined && object.stopCharging !== null
                ? exports.StopCharging.fromPartial(object.stopCharging)
                : undefined;
        message.assignPayment =
            object.assignPayment !== undefined && object.assignPayment !== null
                ? exports.AssignPayment.fromPartial(object.assignPayment)
                : undefined;
        message.problemReported =
            object.problemReported !== undefined && object.problemReported !== null
                ? exports.ProblemReported.fromPartial(object.problemReported)
                : undefined;
        message.cancelTransaction =
            object.cancelTransaction !== undefined &&
                object.cancelTransaction !== null
                ? exports.CancelTransaction.fromPartial(object.cancelTransaction)
                : undefined;
        message.generateReceipt =
            object.generateReceipt !== undefined && object.generateReceipt !== null
                ? exports.GenerateReceipt.fromPartial(object.generateReceipt)
                : undefined;
        message.sendLog =
            object.sendLog !== undefined && object.sendLog !== null
                ? exports.SendLog.fromPartial(object.sendLog)
                : undefined;
        message.heartbeat =
            object.heartbeat !== undefined && object.heartbeat !== null
                ? exports.Heartbeat.fromPartial(object.heartbeat)
                : undefined;
        message.feedback =
            object.feedback !== undefined && object.feedback !== null
                ? exports.FeedbackProvided.fromPartial(object.feedback)
                : undefined;
        message.resourceReport =
            object.resourceReport !== undefined && object.resourceReport !== null
                ? exports.ResourceReport.fromPartial(object.resourceReport)
                : undefined;
        message.validateMembership =
            object.validateMembership !== undefined &&
                object.validateMembership !== null
                ? exports.ValidateMembership.fromPartial(object.validateMembership)
                : undefined;
        message.assignMembership =
            object.assignMembership !== undefined && object.assignMembership !== null
                ? exports.AssignMembership.fromPartial(object.assignMembership)
                : undefined;
        message.getCtepParameterLog =
            object.getCtepParameterLog !== undefined &&
                object.getCtepParameterLog !== null
                ? exports.GetCtepParameterLog.fromPartial(object.getCtepParameterLog)
                : undefined;
        message.useMembershipPresentedAsPayment =
            object.useMembershipPresentedAsPayment !== undefined &&
                object.useMembershipPresentedAsPayment !== null
                ? exports.UseMembershipPresentedAsPayment.fromPartial(object.useMembershipPresentedAsPayment)
                : undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function isSet(value) {
    return value !== null && value !== undefined;
}
